import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { ProgramApiResponse } from '@/models/Program';
import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';

export default function usePrograms() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const getAllPrograms = useCallback(async (): Promise<ProgramApiResponse[]> => {
    const fetchUrl = `${baseUrl}programs`;

    const response = await customFetch<ProgramApiResponse[]>(fetchUrl, {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${authResult.accessToken}`,
      },
    });
    return response;
  }, [authResult, customFetch]);

  return { getAllPrograms };
}
